<template>
  <div ref="WeddingInvitation" class="text-justify transparent">
    <h1 class="text-center">{{ $t("portfolio.weddingInvitation.pageLabel") }}</h1>
    <hr class="primary" />

    <h2>{{ $t("portfolio.weddingInvitation.subtitleA") }}</h2>
    <hr class="secondary" />
    <p>
      {{ $t("portfolio.weddingInvitation.paragraphA1") }}
    </p>
    <p>
      {{ $t("portfolio.weddingInvitation.paragraphA2") }}
    </p>

    <h2>{{ $t("portfolio.weddingInvitation.subtitleB") }}</h2>
    <hr class="secondary" />
    <p>
      {{ $t("portfolio.weddingInvitation.paragraphB1") }}
    </p>
    <ul>
      <li
        v-for="(text, index) in $t('portfolio.weddingInvitation.listB1')"
        :key="`listB1-${index}`"
      >
        <b class="text-white-purple">{{ text }}</b>
      </li>
    </ul>
    <p>
      {{ $t("portfolio.weddingInvitation.paragraphB2") }}
    </p>
    <ul>
      <li
        v-for="(text, index) in $t('portfolio.weddingInvitation.listB2')"
        :key="`listB2-${index}`"
        v-html="text"
      ></li>
    </ul>
    <p>
      {{ $t("portfolio.weddingInvitation.paragraphB3") }}
      <a
        :href="$t('portfolio.weddingInvitation.link')"
        class="general-anchor decorated"
        rel="noreferrer,noopener"
        target="_blank"
      >
        <span>{{ $t("portfolio.weddingInvitation.linkText") }}</span> </a
      >.
    </p>

    <h2>
      {{ $t("portfolio.weddingInvitation.subtitleC") }}
    </h2>
    <hr class="secondary" />
    <p>
      {{ $t("portfolio.weddingInvitation.paragraphC1") }}
    </p>
    <div class="text-center">
      <video :width="videoWidth" height="auto" controls>
        <source
          :src="`${$store.state.Global.env.AWS_S3_PATH}cv/videos/wedding-invitation-admin.mp4`"
          type="video/mp4"
        />
        {{ $t("portfolio.weddingInvitation.videoNotSupported") }}
      </video>
    </div>

    <h2>{{ $t("portfolio.weddingInvitation.subtitleD") }}</h2>
    <hr class="secondary" />
    <p>
      {{ $t("portfolio.weddingInvitation.paragraphD1") }}
    </p>
    <div class="text-center">
      <video :width="videoWidth" height="auto" controls>
        <source
          :src="`${$store.state.Global.env.AWS_S3_PATH}cv/videos/wedding-invitation-guest.mp4`"
          type="video/mp4"
        />
        <source
          :src="`${$store.state.Global.env.AWS_S3_PATH}cv/videos/wedding-invitation-guest.mov`"
        />
        {{ $t("portfolio.weddingInvitation.videoNotSupported") }}
      </video>
    </div>
  </div>
</template>

<script>
export default {
  name: "WeddingInvitation",
  computed: {
    videoWidth() {
      const { width } = this.$store.state.Global.window;
      const { small, medium, large } = this.$utils.styles.breakpoints;
      let videoWidth = width * 0.7125;

      if (width < small) {
        videoWidth = width * 0.95;
      } else if (width < medium) {
        videoWidth = width * 0.5125;
      } else if (width < large) {
        videoWidth = width * 0.625;
      }

      return videoWidth;
    }
  }
};
</script>
